import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import DropzoneS3Uploader from "react-dropzone-s3-uploader";
import UUID from "uuid/v4";
import Loader from "react-loader-advanced";
import CircularProgress from "material-ui/CircularProgress";
import ReactS3Uploader from "react-s3-uploader";

import Config from "../../config";
import { createRequestOptions } from "../../services/utils";
import { getAwsSignedUrl } from "../../services/directcalls";
import colors from "../../styles/colors";
import "../../resources/styles/ImagePicker.css";
import { StyledDropZone } from "react-drop-zone";
import S3Upload from "react-s3-uploader/s3upload.js";
import DeleteButton from "./DeleteButton";
import Delete from "material-ui/svg-icons/action/delete-forever";
import { IconButton } from "@material-ui/core";

import { isMobile } from "react-device-detect";

const style = {
  container: {
    margin: 10,
    display: "flex",
    flexFlow: "row",
  },
  header: {
    margin: 5,
    fontSize: 16,
    color: colors.primary,
    fontFamily: "Poppins-Regular",
  },
  text: {
    fontSize: 12,
    color: colors.primary,
    fontFamily: "Poppins-Regular",
    margin: 0,
  },
};

class ImagePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageUrl: !_.isEmpty(props.imageUrl) ? props.imageUrl : "",
      isUploading: false,
      progress: 0,
      error: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEmpty(nextProps.imageUrl)) {
      this.setState({
        imageUrl: nextProps.imageUrl,
      });
    }
  }

  render() {
    let fileName = "images/" + this.props.userId + "/" + UUID() + ".jpg";

    const uploadFile = async (file) => {
      let upload = new S3Upload({
        files: [file],
        getSignedUrl,
        onProgress: onProgress,
        onFinishS3Put: onFinish,
      });
    };

    const getSignedUrl = (file, callback) => {
      getAwsSignedUrl(this.props.userId, fileName, file, callback, () => {
        this.setState({
          isUploading: false,
          error: "Error uploading the image: internal error",
        });
      });
    };

    // preprocess
    const preprocess = (file, next) => {
      if (file.size > 10000000) {
        this.setState({
          isUploading: false,
          error: "Image is too big. Please choose an image under 10M.",
        });
      } else {
        this.setState({
          error: "",
        });
        return next(file);
      }
    };

    // Progress
    const onProgress = (percent, message) => {
      this.setState({ progress: percent });
      if (!this.state.isUploading && percent < 100) {
        this.setState({ isUploading: true });
      }
    };
    const $progressBar = <div></div>;
    let showProgress = this.state.progress > 0 && this.state.progress < 100;

    // error
    const onError = (message) => {
      this.setState({
        isUploading: false,
        error: "Error uploding the image: " + message,
      });
    };

    // finish
    const onFinish = (data) => {
      let imageUrl = Config.s3.s3Url + "/" + data.fileName;
      this.setState({
        isUploading: false,
        imageUrl,
      });
      this.props.handleSubmit(imageUrl);
    };

    const onClear = () => {
      if (this.props.clearImage) {
        this.setState({
          isUploading: false,
          imageUrl: null,
          progress: 0,
        });
        this.props.clearImage();
      }
    };

    return (
      <div>
        {!this.state.imageUrl && (
          <div className={"image-picker-box"} key={this.state.imageUrl}>
            <Loader
              key={this.state.imageUrl}
              show={this.state.isUploading}
              message={
                <div>
                  <div style={{ marginBottom: 30 }}>
                    Uploading image... Progress: {this.state.progress}%
                  </div>
                  <CircularProgress
                    mode="determinate"
                    value={this.state.progress}
                  />
                </div>
              }
              className={"full-size"}
            >
              {this.state.isUploading && $progressBar}
              {!this.state.imageUrl &&
                this.state.progress === 0 &&
                !this.state.isUploading &&
                !!!isMobile && (
                  <StyledDropZone
                    onDrop={(file, text) => uploadFile(file)}
                    accept="image/*"
                    className={"image-picker-box-dropzone"}
                  >
                    <h3 style={style.header}>Upload Image File</h3>
                    <p style={style.text}>
                      Drag and Drop Image File or <u>Click HERE to Browse</u>
                      <p>
                        Supported image file types include: .xbm, .tif, .pjp,
                        .apng, .svgz, .jpg, .jpeg, .heif, .ico, .tiff, .webp,
                        .jfif, .heic, .gif, .svg, .png, .bmp, .pjpeg, and .avif.
                      </p>
                    </p>
                  </StyledDropZone>
                )}
              {!this.state.imageUrl &&
                this.state.progress === 0 &&
                !this.state.isUploading &&
                !!isMobile && (
                  <div style={{ width: "100%", textAlign: "center" }}>
                    <h3 style={style.header}>Upload Image File</h3>
                    <p style={style.text}>Select an image to upload</p>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(event) => {
                        uploadFile(event.target.files[0]);
                      }}
                    />
                  </div>
                )}
            </Loader>
          </div>
        )}
        {this.state.imageUrl && (
          <div
            style={{
              position: "relative",
              height: 250,
              width: 400,
              backgroundImage: "url(" + this.state.imageUrl + ")",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              border: "1px solid black",
              borderRadius: 3,
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <IconButton
              style={{
                position: "absolute",
                top: 5,
                right: 5,
                border: "solid 1px black",
                backgroundColor: "#fafafa",
              }}
              onClick={onClear}
            >
              <Delete />
            </IconButton>
          </div>
        )}
      </div>
    );
  }
}

ImagePicker.propTypes = {
  imageUrl: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  previewStyle: PropTypes.object,
  userId: PropTypes.number.isRequired,
};

export default ImagePicker;



// WEBPACK FOOTER //
// ./src/components/common/ImagePicker.js